import { Box, Card, CardContent, Skeleton, Stack } from '@mui/material';

const AgentTemplateSkeleton = () => {
  return (
    <Card
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative'
      }}
    >
      <CardContent sx={{ flexGrow: 1, p: 2 }}>
        <Box display='flex' alignItems='center' justifyContent='space-between' mb={2}>
          <Box display='flex' alignItems='center' gap={1}>
            <Skeleton variant='circular' width={40} height={40} />
            <Box>
              <Skeleton variant='text' width={20} height={20} />
            </Box>
          </Box>
          <Skeleton variant='circular' width={32} height={32} />
        </Box>

        <Skeleton variant='text' width='60%' height={32} sx={{ mb: 1 }} />

        <Box mb={2} sx={{ minHeight: 40 }}>
          <Skeleton variant='text' width='100%' height={20} sx={{ mb: 0.5 }} />
          <Skeleton variant='text' width='80%' height={20} />
        </Box>

        <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
          <Stack direction='row' spacing={0.5} flexWrap='wrap' gap={0.5} mb={2} sx={{ minHeight: 60 }}>
            <Skeleton variant='rounded' width={120} height={20} />
            <Skeleton variant='rounded' width={80} height={20} />
            <Skeleton variant='rounded' width={70} height={20} />
            <Skeleton variant='rounded' width={90} height={20} />
          </Stack>

          <Box display='flex' justifyContent='space-between' alignItems='center' mt='auto'>
            <Skeleton variant='text' width={80} height={20} />
            <Skeleton variant='rounded' width={60} height={32} />
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default AgentTemplateSkeleton;
